
<ng-select
  [searchable]="false"
  [clearable]="false"
  placeholder="{{ placeholder }}"
  (change)="sortList($event)"
  [ngModel]="selectedOption"
  [attr.aria-label]="selectedLabel || placeholder"
  >
  @for (sort of sortOptions; track sort) {
    <ng-option [value]="sort.code">{{
      sort.name ? sort.name : sortLabels ? sortLabels[sort.code] : ''
    }}</ng-option>
  }
</ng-select>
